/**
 * Phase 16c.1: the words of chat models per package and per team, the own skill and connection limits, the Pro dialog
 * (B2cProYakinda, B2cModelPro), the marketing consent and the unsubscribe page (merged in index.ts under `b2cModels`).
 * Turkish first; the English mirrors it key for key. Nothing says "Şirket dışı" (left out on purpose).
 */
export const b2cModelsTr = {
  b2cModels: {
    plans: {
      note: 'Ücretsiz’in modeli ya da Pro’nun model listesi değişince seçiciler hemen güncellenir. Pro’dan model çıkarmak hak azaltmasıdır: mevcut abonelere en az 30 gün önce e-postayla haber verilir. Ücretsiz’in sınırları daralırsa değişiklik 7 gün sonra yürürlüğe girer.',
      fields: { maxOwnSkills: 'Kendi skill’leri', maxOwnConnections: 'Kendi bağlantıları (MCP)' },
      units: { skills: 'skill', connections: 'bağlantı' },
      unlimited: 'Sınırsız',
      ownHint: '0 yazarsanız kapalı olur; boş bırakırsanız sınırsız. Oppy ile gelen skill’ler sayılmaz.',
      waiting_one: ' · {{value}} kişi ödemeler açılınca haber bekliyor',
      waiting_other: ' · {{value}} kişi ödemeler açılınca haber bekliyor',
      freeModel: {
        title: 'Sohbet modeli',
        hint: 'Ücretsiz pakette tek model olur. Kişiler diğer modelleri seçicide Pro rozetiyle görür.',
        none: 'Model seçin',
      },
      proModels: {
        title: 'Sohbet modelleri',
        hint: 'Sağlayıcılar ve modeller’de sohbete açılan modeller. İşaretlediklerinizi Pro’lular seçebilir.',
        default: 'Varsayılan',
        newChat: 'Yeni sohbette seçili gelen',
      },
      errors: { oneModel: 'Ücretsiz’e bir sohbet modeli seçin.', someModel: 'Pro’ya en az bir sohbet modeli seçin.' },
    },
    picker: {
      label: 'Sohbet modeli',
      title: 'Sohbet modeli',
      inFree: 'Ücretsiz paketinizde',
      proGroup: 'Pro ile',
      pro: 'Pro',
      locked: '{{model}}: Pro paketinde',
      more: 'Diğer modeller Pro’da',
      compare: 'Paketleri karşılaştır',
      notYours: 'Bu sohbetin modeli ({{model}}) artık paketinizde değil. Devam etmek için başka bir model seçin.',
    },
    offer: {
      soon: {
        title: 'Pro çok yakında',
        body: 'Ödemeler açılınca buradan tek adımda Pro’ya geçebilirsiniz. O zamana kadar Ücretsiz paketle devam edin.',
        modelBody: 'Bu model Pro paketinde. Ödemeler açılınca buradan tek adımda Pro’ya geçebilirsiniz; o zamana kadar Ücretsiz pakette {{free}} ile devam edin.',
      },
      model: {
        title: '{{model}} Pro paketinde',
        body: 'Bu modeli seçmek için Pro’ya geçin. Ücretsiz pakette {{free}} ile devam edebilirsiniz.',
      },
      open: {
        title: 'Pro’ya geçin',
        body: 'Pro’da daha çok token, belge, model ve kendi skill’leriniz var.',
      },
      current: 'Şu anki paketiniz',
      heavy: 'Her gün yoğun kullananlar için',
      perMonth: '/ ay',
      noCard: 'Kart gerekmez',
      vatYearly: 'KDV dahil · yıllık {{price}}',
      freeMonths: '({{count}} ay bedava)',
      tokens: 'Günde {{tokens}} token',
      tokensTimes: '{{times}} kat',
      documents_one: '{{value}} belge',
      documents_other: '{{value}} belge',
      fileSize: 'Dosyalar en çok <b>{{mb}} MB</b>',
      models_one: '{{value}} sohbet modeli',
      models_other: '{{value}} sohbet modeli',
      modelsIncluded: '{{names}} dahil',
      skills_one: '{{value}} kendi skill’iniz',
      skills_other: '{{value}} kendi skill’iniz',
      unlimitedSkills: '<b>Sınırsız</b> kendi skill’iniz',
      connections_one: '{{value}} kendi bağlantınız (MCP)',
      connections_other: '{{value}} kendi bağlantınız (MCP)',
      unlimitedConnections: '<b>Sınırsız</b> kendi bağlantınız (MCP)',
      unlimitedBoth: '<b>Sınırsız</b> kendi skill’iniz ve bağlantınız (MCP)',
      noConnections: 'Kendi bağlantılarınız',
      notify: {
        title: 'Ödemeler açılınca haber verelim mi?',
        body: '{{email}} adresine bir kez e-posta göndeririz.',
        action: 'Bana haber ver',
        done: 'Haber vereceğiz',
        doneBody: 'Ödemeler açılınca {{email}} adresine bir kez e-posta göndereceğiz.',
      },
      keep: 'Sohbetleriniz ve belgeleriniz Pro’ya geçince olduğu gibi kalır.',
      cancelAnytime: 'İstediğiniz zaman iptal edebilirsiniz · sohbetleriniz ve belgeleriniz olduğu gibi kalır',
      notNow: 'Şimdi değil',
      upgrade: 'Pro’ya geç',
      ok: 'Tamam',
    },
    skills: {
      count: '{{used}} / {{limit}}',
      kept_one: '{{count}} skill',
      kept_other: '{{count}} skill',
      countLabel: 'kendi skill’iniz',
      limitTitle: '{{plan}} pakette en çok {{limit}} skill ekleyebilirsiniz.',
      limitBody: 'Yenisini eklemek için birini silin ya da Pro’ya geçin; Pro’da sınır yok. Oppy ile gelen skill’ler sayılmaz.',
      limitBodyNoOffer: 'Yenisini eklemek için birini silin. Oppy ile gelen skill’ler sayılmaz.',
      offTitle: '{{plan}} pakette kendi skill’inizi ekleyemezsiniz.',
      locked: 'Skill ekle: paketinizin sınırı dolu',
    },
    connections: {
      count: '{{used}} / {{limit}}',
      countLabel: 'kendi bağlantınız',
      // 16c.2 (B2cBaglantiSiniri): "Ücretsiz pakette 1 bağlantı ekleyebilirsiniz."; Pro's own limit when it has one
      limitTitle_one: '{{plan}} pakette {{limit}} bağlantı ekleyebilirsiniz.',
      limitTitle_other: '{{plan}} pakette {{limit}} bağlantı ekleyebilirsiniz.',
      limitBody_one: 'Başkasını eklemek için bunu kaldırın ya da Pro’ya geçin; Pro’da sınır yok.',
      limitBody_other: 'Başkasını eklemek için birini kaldırın ya da Pro’ya geçin; Pro’da sınır yok.',
      limitBodyProLimit_one: 'Başkasını eklemek için bunu kaldırın ya da Pro’ya geçin; Pro’da {{pro}} bağlantı.',
      limitBodyProLimit_other: 'Başkasını eklemek için birini kaldırın ya da Pro’ya geçin; Pro’da {{pro}} bağlantı.',
      limitBodyNoOffer_one: 'Başkasını eklemek için bunu kaldırın.',
      limitBodyNoOffer_other: 'Başkasını eklemek için birini kaldırın.',
      section: 'Kendi bağlantılarınız',
      locked: 'Bağlantı ekle: paketinizin sınırı dolu',
      ask: 'Önemli işlemlerden (silme, paylaşma) önce Oppy size sorar.',
      empty: 'Henüz bağlantınız yok. “Bağlantı ekle” ile ilkini ekleyin.',
    },
    compare: {
      chatModels: 'Sohbet modelleri',
      ownSkills: 'Kendi skill’leri',
      ownConnections: 'Kendi bağlantıları (MCP)',
      unlimited: 'Sınırsız',
      none: 'Yok',
    },
    consent: {
      title: 'Kampanya e-postaları',
      hint: 'Oppy’nin yenilikleri ve kampanyaları için arada bir e-posta.',
      on: 'Kampanya e-postası almak istiyorum',
      changed: 'Son değişiklik: {{date}}',
      withdrawn: 'Kampanya izniniz geri alındı.',
      given: 'Kampanya izni verdiniz.',
    },
    unsubscribe: {
      title: 'E-posta listesinden çıkın',
      body: 'Oppy’nin kampanya e-postalarını artık almak istemiyorsanız aşağıdaki düğmeye basın. Hesabınızla ilgili zorunlu e-postalar (kod, makbuz, güvenlik) gelmeye devam eder.',
      action: 'Listeden çık',
      done: 'Listeden çıktınız',
      doneBody: 'Artık kampanya e-postası göndermeyeceğiz. Fikrinizi değiştirirseniz Ayarlar’dan yeniden açabilirsiniz.',
      invalid: 'Bu bağlantı geçerli değil',
      invalidBody: 'Bağlantıyı e-postadaki gibi tam açtığınızdan emin olun ya da Ayarlar’dan kampanya iznini kapatın.',
    },
  },
};

export const b2cModelsEn: typeof b2cModelsTr = {
  b2cModels: {
    plans: {
      note: 'When Free’s model or Pro’s list of models changes, the pickers follow at once. Taking a model out of Pro takes a right away: current subscribers are told by e-mail at least 30 days before. When Free’s limits get stricter, the change takes effect after 7 days.',
      fields: { maxOwnSkills: 'Own skills', maxOwnConnections: 'Own connections (MCP)' },
      units: { skills: 'skills', connections: 'connections' },
      unlimited: 'Unlimited',
      ownHint: 'Write 0 to turn it off; leave it empty for no limit. The skills that come with Oppy do not count.',
      waiting_one: ' · {{value}} person waits to hear when payments open',
      waiting_other: ' · {{value}} people wait to hear when payments open',
      freeModel: {
        title: 'Chat model',
        hint: 'Free has one model. People see the others in the picker with a Pro badge.',
        none: 'Choose a model',
      },
      proModels: {
        title: 'Chat models',
        hint: 'The models opened in chat under Providers and models. Pro people may pick the ones you tick.',
        default: 'Default',
        newChat: 'Selected in a new chat',
      },
      errors: { oneModel: 'Choose one chat model for Free.', someModel: 'Choose at least one chat model for Pro.' },
    },
    picker: {
      label: 'Chat model',
      title: 'Chat model',
      inFree: 'In your Free plan',
      proGroup: 'With Pro',
      pro: 'Pro',
      locked: '{{model}}: in the Pro plan',
      more: 'More models in Pro',
      compare: 'Compare plans',
      notYours: 'This chat’s model ({{model}}) is no longer in your plan. Choose another model to go on.',
    },
    offer: {
      soon: {
        title: 'Pro is coming very soon',
        body: 'Once payments open you can move to Pro here in one step. Until then, go on with the Free plan.',
        modelBody: 'This model is in the Pro plan. Once payments open you can move to Pro here in one step; until then, go on with {{free}} in the Free plan.',
      },
      model: {
        title: '{{model}} is in the Pro plan',
        body: 'Move to Pro to pick this model. You can go on with {{free}} in the Free plan.',
      },
      open: {
        title: 'Move to Pro',
        body: 'Pro has more tokens, documents, models and your own skills.',
      },
      current: 'Your plan now',
      heavy: 'For heavy everyday use',
      perMonth: '/ month',
      noCard: 'No card needed',
      vatYearly: 'VAT included · yearly {{price}}',
      freeMonths: '({{count}} months free)',
      tokens: '{{tokens}} tokens a day',
      tokensTimes: '{{times}} times',
      documents_one: '{{value}} document',
      documents_other: '{{value}} documents',
      fileSize: 'Files up to <b>{{mb}} MB</b>',
      models_one: '{{value}} chat model',
      models_other: '{{value}} chat models',
      modelsIncluded: 'including {{names}}',
      skills_one: '{{value}} own skill',
      skills_other: '{{value}} own skills',
      unlimitedSkills: '<b>Unlimited</b> own skills',
      connections_one: '{{value}} own connection (MCP)',
      connections_other: '{{value}} own connections (MCP)',
      unlimitedConnections: '<b>Unlimited</b> own connections (MCP)',
      unlimitedBoth: '<b>Unlimited</b> own skills and connections (MCP)',
      noConnections: 'Your own connections',
      notify: {
        title: 'Shall we tell you when payments open?',
        body: 'We send one e-mail to {{email}}.',
        action: 'Tell me',
        done: 'We will tell you',
        doneBody: 'We will send one e-mail to {{email}} when payments open.',
      },
      keep: 'Your chats and documents stay as they are when you move to Pro.',
      cancelAnytime: 'Cancel any time · your chats and documents stay as they are',
      notNow: 'Not now',
      upgrade: 'Move to Pro',
      ok: 'OK',
    },
    skills: {
      count: '{{used}} / {{limit}}',
      kept_one: '{{count}} skill',
      kept_other: '{{count}} skills',
      countLabel: 'own skills',
      limitTitle: 'On {{plan}} you can add at most {{limit}} skills.',
      limitBody: 'Delete one to add another, or move to Pro; Pro has no limit. The skills that come with Oppy do not count.',
      limitBodyNoOffer: 'Delete one to add another. The skills that come with Oppy do not count.',
      offTitle: 'On {{plan}} you cannot add your own skills.',
      locked: 'Add skill: your plan’s limit is reached',
    },
    connections: {
      count: '{{used}} / {{limit}}',
      countLabel: 'own connections',
      limitTitle_one: 'On {{plan}} you can add {{limit}} connection.',
      limitTitle_other: 'On {{plan}} you can add {{limit}} connections.',
      limitBody_one: 'To add another, remove this one or move to Pro; Pro has no limit.',
      limitBody_other: 'To add another, remove one or move to Pro; Pro has no limit.',
      limitBodyProLimit_one: 'To add another, remove this one or move to Pro; Pro has {{pro}} connections.',
      limitBodyProLimit_other: 'To add another, remove one or move to Pro; Pro has {{pro}} connections.',
      limitBodyNoOffer_one: 'To add another, remove this one.',
      limitBodyNoOffer_other: 'To add another, remove one.',
      section: 'Your own connections',
      locked: 'Add connection: your plan’s limit is reached',
      ask: 'Oppy asks you before important actions (deleting, sharing).',
      empty: 'You have no connections yet. Add your first one with “Add connection”.',
    },
    compare: {
      chatModels: 'Chat models',
      ownSkills: 'Own skills',
      ownConnections: 'Own connections (MCP)',
      unlimited: 'Unlimited',
      none: 'None',
    },
    consent: {
      title: 'Campaign e-mails',
      hint: 'Now and then an e-mail about what is new at Oppy and its campaigns.',
      on: 'I want campaign e-mails',
      changed: 'Last changed: {{date}}',
      withdrawn: 'Your marketing consent is withdrawn.',
      given: 'You gave your marketing consent.',
    },
    unsubscribe: {
      title: 'Leave the e-mail list',
      body: 'If you no longer want Oppy’s campaign e-mails, press the button below. The e-mails your account needs (codes, receipts, security) still come.',
      action: 'Unsubscribe',
      done: 'You left the list',
      doneBody: 'We will send no more campaign e-mails. If you change your mind, turn them on again in Settings.',
      invalid: 'This link is not valid',
      invalidBody: 'Make sure you opened the link whole, as in the e-mail, or turn the marketing consent off in Settings.',
    },
  },
};
